import { render } from "./network.harvesterhci.io.vlanconfig.vue?vue&type=template&id=2ba8de26"
import script from "./network.harvesterhci.io.vlanconfig.vue?vue&type=script&lang=js"
export * from "./network.harvesterhci.io.vlanconfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__